<script lang="ts">
  interface BannerFeatureTracking {
    id: string;
    name: string;
    status: string;
    labelsJson: string;
  }

  interface BannerValue {
    displayName: string;
    ident: string;
    selected: boolean;
    featureTracking: BannerFeatureTracking;
  }

  interface Props {
    filterId: string;
    filterTitle: string;
    ruleString: string;
    sortKey: string;
    selectionType: string;
    facetVisibility: string;
    facetName: string;
    facetId: string;
    formFeatureTracking: BannerFeatureTracking;
    facetFeatureTracking: BannerFeatureTracking;
    values: BannerValue[];
  }

  const {
    filterId,
    filterTitle,
    ruleString,
    sortKey,
    selectionType,
    facetVisibility,
    facetName,
    facetId,
    formFeatureTracking,
    facetFeatureTracking,
    values,
  }: Props = $props();
</script>

<div id="heureka_filterBannerTemplate" style="display: none">
  <oc-banner-v1 class="heureka_filterBanner" hide-icon="" variant="hint" size="100" data-banner-filter={filterId}>
    <form
      id={`find_filter_${formFeatureTracking.id}`}
      data-ts-feature-name={formFeatureTracking.name}
      data-ts-feature-parent-id="find_filterSection"
      data-ts-feature-status={formFeatureTracking.status}
      data-ts-feature-labels={formFeatureTracking.labelsJson}
      class="find_filter find_filter--banner js_trackOnChange ts_formFilter"
      data-title={filterTitle}
      data-ts-change-labels={JSON.stringify({ san_FacetLocation: "list_initial" })}
      action="/grasshopper/filter/resolve"
      autocomplete="off"
      method="post"
      novalidate
    >
      <input type="hidden" name="rule" value={ruleString} />
      <input type="hidden" name="sortiertnach" value={sortKey} />
      <fieldset
        id={`facet_${facetFeatureTracking.id}`}
        data-ts-feature-name={facetFeatureTracking.name}
        data-ts-feature-parent-id={`find_filter_${filterId}`}
        data-ts-feature-status={facetFeatureTracking.status}
        data-ts-feature-labels={facetFeatureTracking.labelsJson}
        class={`find_facet find_facet--${selectionType}`}
        data-facet-visibility={facetVisibility}
        data-facet-name={facetName}
      >
        <ul>
          {#each values as value (value.ident)}
            <li>
              <oc-switch-v2
                id="facetValue_{facetId}_{value.ident}"
                data-ts-feature-name={value.featureTracking.name}
                data-ts-feature-parent-id={`facet_${facetId}`}
                data-ts-feature-status={value.featureTracking.status}
                data-ts-feature-labels={value.featureTracking.labelsJson}
                class="heureka_filterBanner__switch js_tValue"
                type="checkbox"
                name={facetName}
                value={value.ident}
                {...value.selected ? { checked: "" } : {}}
                size="50"
                fit-content="true"
                label-placement="right">{value.displayName}</oc-switch-v2
              >
            </li>
          {/each}
        </ul>
      </fieldset>
    </form>
  </oc-banner-v1>
</div>
